import React from 'react';
import Banner from '../Banner/Banner';
import TourSpots from '../TourSpots/TourSpots';

const Home = () => {
    return (
        <div id="home">
            <Banner></Banner>
            <TourSpots></TourSpots>
        </div>
    );
};

export default Home;